<template>
  <div class="d-flex image-navigator">
    <div class="image-navigator__folders">
      <fluke-image-navigator-folder
        v-for="category of categories"
        :key="category.id"
        :category="category"
        :selected="isSelectedCategory(category)"
        :image-count="imageList.length"
        :hide-actions="hideFolderActions"
        @click="onSelectCategory"
        @edit="onEditCategory"
        @delete="onDeleteCategory"
      ></fluke-image-navigator-folder>
      <fluke-dialog-form-folder
        v-if="!hideFolderActions"
        :form-type="categoryFormType"
        :category="currentCategoryEdit"
        @update="onUpdateCategory"
        @create="onCreateCategory"
      ></fluke-dialog-form-folder>
    </div>
    <div class="image-navigator__images">
      <div v-if="!hideMoveMulti" class="image-navigator__images__actions">
        <v-menu>
          <template v-slot:activator="{ on }">
            <v-btn
              :disabled="multiSelectImages.length === 0"
              color="#fec402"
              style="padding: 0 20px"
              v-on="on"
              >Mover Imagens Selecionadas</v-btn
            >
          </template>
          <v-list>
            <v-list-tile
              v-for="(item, index) in moveCategoryOptions"
              :key="index"
              @click="() => onChooseAction(item)"
            >
              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
      <div v-if="uploading" class="image-navigator__images__spinner">
        <v-progress-circular indeterminate color="amber" />
      </div>
      <div class="image-navigator__images__list">
        <fluke-image-navigator-image
          v-for="image of imageList"
          :key="image.id"
          :image="image"
          :selected="isSelectedImage(image)"
          :multi-selected="isMultiSelectedImage(image)"
          :hide-edit-in-place="hideEditInPlace"
          :hide-move-multi="hideMoveMulti"
          @click="onSelectImage"
          @update="onUpdateImage"
          @multi-select="onMultiSelectImage"
        ></fluke-image-navigator-image>
      </div>
    </div>
  </div>
</template>

<script>
import ImageNavigatorFolder from "./ImageNavigatorFolder.vue";
import ImageNavigatorImage from "./ImageNavigatorImage.vue";
import DialogFormFolder from "./DialogFormFolder.vue";
export default {
  props: {
    categories: Array,
    images: Array,
    selectedImage: String,
    selectedCategory: Number,
    hideEditInPlace: Boolean,
    uploading: Boolean,
    hideMoveMulti: Boolean,
    hideFolderActions: Boolean,
  },
  components: {
    "fluke-image-navigator-folder": ImageNavigatorFolder,
    "fluke-image-navigator-image": ImageNavigatorImage,
    "fluke-dialog-form-folder": DialogFormFolder,
  },
  data() {
    return {
      currentCategory: null,
      currentImage: null,
      categoryFormType: "create",
      currentCategoryEdit: null,
      multiSelectImages: [],
    };
  },
  methods: {
    isSelectedCategory(category) {
      return category.id === this.currentCategory;
    },
    isSelectedImage(image) {
      return (
        this.selectedImage &&
        (+image.id === +this.selectedImage || image.name === this.selectedImage)
      );
    },
    isMultiSelectedImage(image) {
      return this.multiSelectImages.includes(image.id);
    },
    onSelectCategory(category) {
      this.multiSelectImages = [];
      this.currentCategory = category.id;
      this.$emit("select-category", category);
    },
    onSelectImage(image) {
      this.currentImage = image.id;
      this.$emit("select-image", image);
    },
    onUpdateImage(payload) {
      this.$emit("update-image", payload);
    },
    onCreateCategory(payload) {
      this.$emit("create-category", payload);
      this.categoryFormType = "create";
    },
    onUpdateCategory(payload) {
      this.$emit("update-category", {
        ...payload,
        id: this.currentCategoryEdit.id,
      });
      this.currentCategoryEdit = null;
    },
    onDeleteCategory(payload) {
      this.$emit("delete-category", payload);
    },
    onEditCategory(payload) {
      this.categoryFormType = "update";
      this.currentCategoryEdit = payload;
    },
    onMultiSelectImage(image) {
      if (this.multiSelectImages.includes(image.id)) {
        this.multiSelectImages = this.multiSelectImages.filter((id) => {
          return id !== image.id;
        });
      } else {
        this.multiSelectImages.push(image.id);
      }
    },
    onChooseAction(item) {
      this.$emit("move-multi-images", {
        category: item,
        images: this.multiSelectImages,
      });
      this.multiSelectImages = [];
    },
  },
  computed: {
    imageList() {
      return this.images;
    },
    moveCategoryOptions() {
      return this.categories.filter((category) => {
        return category.id !== this.selectedCategory;
      });
    },
  },
  watch: {
    selectedCategory: function (value) {
      if (value !== this.currentCategory) {
        this.$nextTick(() => {
          this.currentCategory = value;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.image-navigator {
  position: relative;
  height: 100%;
  &__folders {
    white-space: nowrap;
    margin-right: 50px;
    position: absolute;
    width: 12vw;
    top: 0;
    left: 0;
    bottom: 0;
    overflow-y: auto;
  }
  &__images {
    margin-left: 14vw;
    &__actions {
      background: white;
      padding: 0 0 10px 0px;
      position: relative;
    }
    &__spinner {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
    }
    &__list {
      overflow-y: auto;
      height: 100%;
      display: grid;
      align-items: flex-start;
      gap: 5px;
      @media (min-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
      }
      @media (min-width: 1024px) {
        grid-template-columns: repeat(4, 1fr);
      }
      @media (min-width: 1366px) {
        grid-template-columns: repeat(5, 1fr);
      }
    }
  }
}
</style>
